/* eslint-disable */
export interface AnchorData {
  /** The target node's ID. */
  anchor: string;
}

const baseAnchorData: object = { anchor: '' };

export const AnchorData = {
  fromJSON(object: any): AnchorData {
    const message = { ...baseAnchorData } as AnchorData;
    message.anchor =
      object.anchor !== undefined && object.anchor !== null ? String(object.anchor) : '';
    return message;
  },

  toJSON(message: AnchorData): unknown {
    const obj: any = {};
    message.anchor !== undefined && (obj.anchor = message.anchor);
    return obj;
  },
};
